import { useDoctorsSuppliersForm } from 'Hooks/useDoctorsSuppliersForm';
import { Form } from 'Modules/Suppliers/SuppliersMain/SearchForms/DoctorsSearchForm/Form';
import { FormProvider } from 'react-hook-form';
import { IForm } from '..';

export const DoctorForm = ({ setOpenModal, selectedOrderBy }: IForm) => {
  const { DoctorsSuppliersForm } = useDoctorsSuppliersForm();
  return (
    <FormProvider {...DoctorsSuppliersForm}>
      <Form
        formSx={{
          border: 'none',
          boxShadow: 'none',
          m: 0,
          p: 0,
          width: '100%',
          maxWidth: '100%',
          alignItems: 'flex-start',
        }}
        callback={() => setOpenModal(false)}
        selectedOrderBy={selectedOrderBy}
      />
    </FormProvider>
  );
};
